module.exports = "<div class=\"container-fluid\">\r\n    <div class=\"col-md-12\">\r\n        <div class=\"row form-group text-center\">\r\n            <span>Are you sure you want to delete Post-Activity?</span>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./app/insa-components/insa-cron/insa-job/insa-job-activities-form/insa-post-actions/post-action-form/delete-post-action.component.html
// module id = 1771
// module chunks = 2